/* eslint-disable sonarjs/no-duplicate-string */
import app from 'Cloud/Application/app';
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { sendAgreement } from 'reactApp/appHelpers/appHelpers';
import { renderLicenseAgreementDialog } from 'reactApp/components/LicenseAgreement/licenseAgreement.toolkit';
import { renderWelcomeAttachesDialogHelper, renderWelcomeDialogHelper } from 'reactApp/components/WelcomeDialog/welcomeDialogToolkit';
import { EAuthDwhAction } from 'reactApp/modules/dwh/dwh.types';
import { isDefaultRootContent } from 'reactApp/modules/home/home.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { showUploaderAction } from 'reactApp/modules/upload/upload.module';
import { store as reduxStore } from 'reactApp/store';
import { sendXray } from 'reactApp/utils/ga';
import { noopVoid } from 'reactApp/utils/helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import { sendAuthDwhRequest } from '../dwh/dwh.module';
import { EnvironmentSelectors } from '../environment/environment';

export const isWelcomePromo = () =>
    app?.isHome() && app.getState && app.getState().id === '/' && isDefaultRootContent(reduxStore.getState());

const showUploader = () => reduxStore.dispatch(showUploaderAction());

const groupAb = getFeature('ab-trial-popup');

const sendFirstEnter = () =>
    sendPaymentGa({
        eventCategory: ECategoryGa.onboarding,
        action: 'first-enter',
        label: '',
        group: groupAb || 'None',
    });

let dialog;
export const renderWelcomeHelper = ({
    storage,
    onSuccess = noopVoid,
    publishMode = false,
    onClose = noopVoid,
}: {
    storage: EStorageType;
    onSuccess?();
    onClose?();
    publishMode?: boolean;
}) => {
    const isPhone = EnvironmentSelectors.isPhone();
    const onAccept = () => {
        sendFirstEnter();
        showUploader();
    };

    if (storage === EStorageType.attaches) {
        dialog = renderWelcomeAttachesDialogHelper({
            publishMode,
            onSuccess: () => {
                sendAgreement('mail_');
                sendXray('ui_welcome_start-mail');
                if (dialog) {
                    dialog.close();
                    dialog = null;
                }
                onSuccess();
                onAccept();
                reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseAccept, source: 'attaches' }));
            },
            onShow: () => reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseOpen, source: 'attaches' })),
        });

        return;
    }

    if (isPhone) {
        renderLicenseAgreementDialog({
            closable: false,
            onSuccess: () => {
                onAccept();
                reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseAccept, source: 'none' }));
            },
        });

        return;
    }

    renderWelcomeDialogHelper({
        onComplete: showUploader,
        onClose: () => {
            onAccept();
            onClose();
            reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseAccept, source: 'none' }));
        },
        onShow: () => reduxStore.dispatch(sendAuthDwhRequest({ action: EAuthDwhAction.licenseOpen, source: 'none' })),
    });
};

export const isWelcomeDialogShown = (): boolean => !!dialog;
